import { GET_PAGE } from "./types";
import axios from "axios";

export default params => async dispatch => {
  const res = await axios.get(`/api/pages`);
  res.data = res.data.sort((v1, v2) => v2.index - v1.index).map(v => v);
  dispatch(getAsync(res.data));
};
const getAsync = data => ({
  type: GET_PAGE,
  payload: data
});
